import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import adminRoutes from "routes/admin-routes";
import PageHeader from "./sections/PageHeader";
import ContainerCard from "components/ContainerCard";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import NewKnowledgeDocument from "./sections/NewKnowledgeDocument";
import ExistingKnowledgeDocument from "./sections/ExistingKnowledgeDocument";
import Breadcrumbs from "examples/Breadcrumbs";
import Container from "@mui/material/Container";

function KnowledgeDocument() {
  const location = useLocation();
  const [knowledgeDocumentId, setKnowledgeDocumentId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlKnowledgeDocumentId = params.get("knowledgeDocumentId");

    if (urlKnowledgeDocumentId) {
      setKnowledgeDocumentId(urlKnowledgeDocumentId);
    }
    setLoading(false);
  }, [location.search]);

  return (
    <>
      <DefaultNavbar routes={adminRoutes} />
      <PageHeader />

      <ContainerCard>
        <Container>
          <Breadcrumbs
            routes={[
              { label: "Admin", route: "/admin" },
              { label: "Chatbot Logica", route: "/admin/agents" },
              { label: "Kennis Document" },
            ]}
          />
        </Container>
        {loading ? (
          <CircularProgress />
        ) : knowledgeDocumentId ? (
          <ExistingKnowledgeDocument knowledgeDocumentId={knowledgeDocumentId} />
        ) : (
          <NewKnowledgeDocument />
        )}
      </ContainerCard>
    </>
  );
}

export default KnowledgeDocument;
